(()=> {
    'use strict';

    angular
        .module('uwAgenda.global')
        .directive(
            'rfGlobalHeader', 
            [
                RfGlobalHeaderFn
            ]
        );

    function RfGlobalHeaderFn() {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: '/app/global/templates/rf-global-header.template.html',
            controller: 'HeaderController',
            controllerAs: 'vm',
            scope: true
        };
    }
})();